import { action } from 'typesafe-actions';

import { ISimilarity } from 'APIPackage/SimilarityModule/interfaces/ISimilarity';
import { ISimilaritiesFilter } from 'APIPackage/SimilarityModule/interfaces/ISimilaritiesFilter';
import { ISimilarityStatusEnum } from 'APIPackage/SimilarityModule/interfaces/ISimilarityStatus';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { ISimilarityMatch } from 'APIPackage/SimilarityModule/interfaces/ISimilarityMatch';
import { ISimilaritiesMatchByPersonFilter } from 'APIPackage/SimilarityModule/interfaces/ISimilaritiesMatchByPersonFilter';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import { SimilaritiesActionsEnum } from '../enums/SimilaritiesActionsEnum';

export const similaritiesInitPage = () => action(SimilaritiesActionsEnum.SIMILARITIES_INIT_PAGE);
export const similaritiesGetData = () => action(SimilaritiesActionsEnum.SIMILARITIES_GET_DATA);
export const similaritiesSetData = (
  data: ISimilarity[],
  page: number,
  pageCount: number,
  totalCount: number,
  notProcessedCount: number,
) => action(SimilaritiesActionsEnum.SIMILARITIES_SET_DATA, { data, page, pageCount, totalCount, notProcessedCount });
export const similaritiesSetOrder = (order: string) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_ORDER, { order });
export const similaritiesGetDataNextPage = () => action(SimilaritiesActionsEnum.SIMILARITIES_GET_DATA_NEXT_PAGE);
export const similaritiesSetSearchString = (searchString: string) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_SEARCH_STRING, { searchString });
export const similaritiesSetFilters = (filter: ISimilaritiesFilter) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_FILTER, { filter });
export const similaritiesChangeStatus = (
  status: ISimilarityStatusEnum,
  id: string,
  startDate?: string,
  filter?: ISimilaritiesFilter,
  isId?: boolean,
) => action(SimilaritiesActionsEnum.SIMILARITIES_CHANGE_STATUS, { status, id, startDate, filter, isId });
export const similaritiesExportList = (
  format: ExportFormatsEnum,
  filters: ISimilaritiesFilter,
  exportNotify: ({ id }: IExport) => void,
) => action(SimilaritiesActionsEnum.SIMILARITIES_EXPORT_LIST, { format, filters, exportNotify });
export const similaritiesGetDataById = () => action(SimilaritiesActionsEnum.SIMILARITIES_GET_DATA_BY_ID);
export const similaritiesSetDataById = (similaritiesById: ISimilarityMatch[]) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_DATA_BY_ID, { similaritiesById });
export const similaritiesSetOrderById = (order: string) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_ORDER_BY_ID, { order });
export const similaritiesSetFiltersById = (filter: ISimilaritiesMatchByPersonFilter) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_FILTER_BY_ID, { filter });
export const similaritiesSetPersonId = (id: string) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_PERSON_ID, { id });
export const similaritiesExportById = (
  format: ExportFormatsEnum,
  personId: string,
  filters: ISimilaritiesMatchByPersonFilter,
  exportNotify: ({ id }: IExport) => void,
) => action(SimilaritiesActionsEnum.SIMILARITIES_EXPORT_BY_ID, { format, personId, filters, exportNotify });
export const similaritiesGetFetchSettingByCode = (code: AdminSettingCodesEnum) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_GET_FETCH_SETTING_BY_CODE, { code });
export const similaritiesSetFetchSettingByCode = (settings: IAdminSetting) =>
  action(SimilaritiesActionsEnum.SIMILARITIES_SET_FETCH_SETTING_BY_CODE, { settings });
